import { createReducer, on } from '@ngrx/store';
import * as timeBasedWorkProposition from '../actions/time-based-work-proposition.actions';
import { TimeBasedWorkProposition } from '../../models/time-based-work-proposition.model';

export interface TimeBasedWorkPropositionState {
  timeBasedWorkProposition: TimeBasedWorkProposition[];
  error: any;
  loading: boolean;
}

export const initialState: TimeBasedWorkPropositionState = {
  timeBasedWorkProposition: [],
  error: null,
  loading: true,
};

export const timeBasedWorkPropositionReducer = createReducer(
  initialState,

  // Load actions
  on(timeBasedWorkProposition.loadTimeBasedWorkProposition, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(
    timeBasedWorkProposition.loadTimeBasedWorkPropositionSuccess,
    (state, { timeBasedWorkProposition: propositions }) => ({
      ...state,
      timeBasedWorkProposition: propositions,
      loading: false,
      error: null,
    })
  ),

  on(
    timeBasedWorkProposition.loadTimeBasedWorkPropositionFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })
  ),

  // Batch operations loading states
  on(
    timeBasedWorkProposition.deleteMultipleTimeBasedWorkPropositions,
    timeBasedWorkProposition.createMultipleTimeBasedWorkPropositions,
    timeBasedWorkProposition.updateMultipleTimeBasedWorkPropositions,
    (state) => ({
      ...state,
      loading: true,
      error: null,
    })
  ),

  on(
    timeBasedWorkProposition.deleteMultipleTimeBasedWorkPropositionsSuccess,
    (state, { uids }) => ({
      ...state,
      timeBasedWorkProposition: state.timeBasedWorkProposition.filter(
        (proposition) => !uids.includes(proposition.uid)
      ),
      loading: false,
      error: null,
    })
  ),

  on(
    timeBasedWorkProposition.createMultipleTimeBasedWorkPropositionsSuccess,
    (state, { timeBasedWorkPropositions }) => ({
      ...state,
      timeBasedWorkProposition: [
        ...state.timeBasedWorkProposition,
        ...timeBasedWorkPropositions,
      ],
      loading: false,
      error: null,
    })
  ),

  on(
    timeBasedWorkProposition.updateMultipleTimeBasedWorkPropositionsSuccess,
    (state, { timeBasedWorkPropositions }) => ({
      ...state,
      timeBasedWorkProposition: state.timeBasedWorkProposition.map(
        (proposition) => {
          const updated = timeBasedWorkPropositions.find(
            (tbwp) => tbwp.uid === proposition.uid
          );
          return updated || proposition;
        }
      ),
      loading: false,
      error: null,
    })
  ),

  // Error handling
  on(
    timeBasedWorkProposition.deleteMultipleTimeBasedWorkPropositionsFailure,
    timeBasedWorkProposition.createMultipleTimeBasedWorkPropositionsFailure,
    timeBasedWorkProposition.updateMultipleTimeBasedWorkPropositionsFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })
  )
);
